import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';

// This is suggestion for update the imports of angular material and separate these of components and services of file App-module

const angularMaterialImports = [
  DragDropModule,
  MatAutocompleteModule,
  MatAutocompleteModule,
  MatCardModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatInputModule,
  MatTooltipModule,
];

@NgModule({
  imports: [...angularMaterialImports],
  exports: [...angularMaterialImports],
  declarations: [],
  providers: [],
})
export class AngularMaterialModule {}
